webpackJsonp([230064834116715],{

/***/ 935:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/2--starters/index.md absPath of file >>> MarkdownRemark","html":"","frontmatter":{"title":"My Works"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Built by <a href=\"https://www.linkedin.com/in/suyogkc/\">Suyog K.C</a></li>\n<li>with <a href=\"https://www.gatsbyjs.org/\">Gatsby</a> &#x26; <a href=\"https://reactjs.org\">React</a></li>\n<li>source code on <a href=\"https://github.com/suyogkrazz/krazzyblog\">GitHub</a></li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":"434176823700987"}}}},"pathContext":{"slug":"/starters/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---starters-01153150ac9834cd50f5.js